"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhoIsRegisteredKeeperWidgetNB = void 0;
var React = require("react");
var DriverKeeperPopupWidget_1 = require("../subscription/motor/DriverKeeperPopupWidget");
var commonFunctions_1 = require("../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var WhoIsRegisteredKeeperWidgetNB = /** @class */ (function (_super) {
    __extends(WhoIsRegisteredKeeperWidgetNB, _super);
    function WhoIsRegisteredKeeperWidgetNB(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.handleOnChangeEvent = function (event) {
            _this.props.onStateChange(_this.props.question.interactionField, event.target.value);
            _this.setState({
                registeredKeeperId: event.target.value,
                showConfirmation: false
            });
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        var registeredKeeper = _this.props.interaction.vehicles[_this.vehicleIndex].registeredKeeperId ?
            _this.props.interaction.vehicles[_this.vehicleIndex].registeredKeeperId : "";
        _this.state = {
            registeredKeeperId: registeredKeeper,
            showConfirmation: false,
            redirect: false
        };
        return _this;
    }
    WhoIsRegisteredKeeperWidgetNB.prototype.renderInputField = function () {
        var _this = this;
        return (React.createElement("div", { className: "background-color-white" },
            React.createElement("div", { className: "media-body" }, this.renderHeader()),
            React.createElement(DriverKeeperPopupWidget_1.default, { show: this.state.showConfirmation, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: function () { return _this.props.engine.navigate("addDriver", false); }, title: "Registered keeper for this car", vehicleRegistrationNumber: "".concat(this.props.interaction.vehicles[this.vehicleIndex].registrationNumber), additionalDriversCount: this.props.interaction.additionalDrivers ? this.props.interaction.additionalDrivers.length : 0, driverFunction: "registered keeper" }),
            this.renderDrivers()));
    };
    WhoIsRegisteredKeeperWidgetNB.prototype.checkRegisteredKeeper = function (driverId) {
        var registeredKeeperId = this.props.interaction.vehicles[this.vehicleIndex].registeredKeeperId;
        if (!registeredKeeperId || registeredKeeperId === "") {
            return false;
        }
        return registeredKeeperId === driverId;
    };
    WhoIsRegisteredKeeperWidgetNB.prototype.renderHeader = function () {
        var drivers = [];
        drivers.push(this.props.interaction.policyHolder);
        this.props.interaction.additionalDrivers && drivers.push.apply(drivers, this.props.interaction.additionalDrivers);
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        return (React.createElement("label", null,
            "Who is the registered keeper for ",
            vehicle.make,
            ", ",
            vehicle.model,
            " (",
            vehicle.registrationNumber,
            ")?"));
    };
    WhoIsRegisteredKeeperWidgetNB.prototype.renderDrivers = function () {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var allDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var vehicleDrivers = [];
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model, " ").concat(vehicle.registrationNumber);
        vehicle.driverIds.forEach(function (driverId) {
            var foundDriver = allDrivers.find(function (driver) { return driver.personId && driverId === driver.personId; });
            if (foundDriver) {
                vehicleDrivers.push(React.createElement("option", { key: driverId, value: driverId },
                    foundDriver.firstName,
                    " ",
                    foundDriver.lastName));
            }
        });
        return (React.createElement("div", { className: "input-group margin-top-14", role: "group", "aria-label": "Who is registered keeper for ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation), "?") },
            React.createElement("select", { id: "registeredKeeper", className: "form-control ".concat(this.getInputValidationClass()), onChange: this.handleOnChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, value: this.bindFromField(this.props.question.interactionField) || "" },
                React.createElement("option", { disabled: true, value: "" }, "Please select..."),
                vehicleDrivers)));
    };
    return WhoIsRegisteredKeeperWidgetNB;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.WhoIsRegisteredKeeperWidgetNB = WhoIsRegisteredKeeperWidgetNB;
//# sourceMappingURL=WhoIsRegisteredKeeperWidgetNB.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/WhoIsRegisteredKeeperWidgetNB.js
// module id = 3447
// module chunks = 0